import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ToasterServiceService } from '../../service/toaster.service';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-village-list',
  templateUrl: './village-list.component.html',
  styleUrl: './village-list.component.scss'
})
export class VillageListComponent implements OnInit{
  VillageList: any = [];
  originalVillageListData: any[] = [];

  constructor(
    private router: Router,
    private toasterService: ToasterServiceService,
    private location: Location,
    private mainService: MainService
  ) { }

  ngOnInit() {
    this.VillageMembersList();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  ListMainMember(village_id: any) {
    this.mainService.selectDistrict = village_id;
    this.router.navigate(['/committee/village-member-list/' + village_id]);
  }

  searchVillage(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      //this.VillageMembersList();
      this.VillageList = [...this.originalVillageListData];
      return;
    }
    this.VillageList = this.originalVillageListData.filter((data: any) => {
      return data.village_name.toLowerCase().includes(filterValue)
    });
  }

  VillageMembersList() {
    let data = {
      subdivision_id: 0,
      village_id: 0,
      village_name: "",
      Action: 'VILLAGMEMBERCOUNT',
    };
    this.mainService.putApi(ApiUrls.editVillage, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.VillageList = res.village;
        this.originalVillageListData = res.village;
      }
      else {
        this.toasterService.toastError(res.response);
      }
    });
  }

}
